import React from 'react';
import { bool, array, string, func } from 'prop-types';
import useStyles from 'hooks/useStyles';

import Link from 'components/Link';
import { DropdownButton, DropdownItem } from 'components/DropdownButton';
import { MaterialIcon } from 'components/Icon';

import styles from './MaterialDropdownButton.scss';

function MaterialDropdownButton({
  isDisabled,
  materials,
  btnText,
  onClick,
  onClickMaterial,
  className,
}) {
  useStyles(styles);

  const renderMaterialDropdown = (material, index) => {
    const { title, file, id } = material;
    const handleClickMaterial = () =>
      typeof onClickMaterial === 'function' &&
      onClickMaterial({ ...material, index });

    return (
      <li key={id}>
        <Link to={file} newTab onClick={handleClickMaterial}>
          <DropdownItem
            className={styles.dropdownItem}
            icon={<MaterialIcon width={20} height={20} />}
          >
            {title}
          </DropdownItem>
        </Link>
      </li>
    );
  };

  return (
    <DropdownButton
      className={className}
      isDisabled={isDisabled}
      dropdownList={materials}
      onClick={onClick}
      renderDropdownItemComponent={renderMaterialDropdown}
    >
      <MaterialIcon width={16} height={16} className={styles.icon} />
      <div className={styles.text}>{btnText}</div>
    </DropdownButton>
  );
}

MaterialDropdownButton.propTypes = {
  isDisabled: bool.isRequired,
  materials: array.isRequired,
  className: string.isRequired,
  btnText: string.isRequired,
  onClick: func,
  onClickMaterial: func,
};

MaterialDropdownButton.defaultProps = {
  onClick: undefined,
  onClickMaterial: undefined,
};

export default MaterialDropdownButton;
